import { render, staticRenderFns } from "./widget-comment.vue?vue&type=template&id=6b364a0e&"
import script from "./widget-comment.vue?vue&type=script&lang=js&"
export * from "./widget-comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports